import { EventSourceHandler } from '@sellsy/sse';

export default class OcrFailedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'staff.ocr.failed';
    }

    handle(event) {
        EventBus.emit('ocr:failed', event.data);
    }
}
